export default function languages() {
    if(document.querySelector(".languages")) {
        let languages = document.querySelectorAll(".languages");

        Array.from(languages)[1].addEventListener("click", () => {
            Array.from(languages)[1].classList.toggle("active");
        });
    }
}